export default {
  title: 'Aktivér notifikationer for eksklusive tilbud og opdateringer',
  description: 'Få ordreopdateringer i realtid. Følg leveringsstatus. Eksklusive tilbud og fordele.',
  buttons: {
    confirm: 'Aktivér',
    cancel: 'Ikke nu',
  },
};
